import { render, staticRenderFns } from "./GroupSessionDetailsChangedNotification.vue?vue&type=template&id=9684ba38&scoped=true&"
import script from "./GroupSessionDetailsChangedNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionDetailsChangedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9684ba38",
  null
  
)

export default component.exports